import colors from "../../base/colors";
import pxToRem from "../../functions/pxToRem";

const { transparent, text } = colors;

const select = {
  styleOverrides: {
    select: {
      display: "flex",
      alignItems: "center",
      minHeight: pxToRem(20),
      padding: `${pxToRem(6)} ${pxToRem(32)} ${pxToRem(6)} ${pxToRem(10)} !important`,
      fontSize: pxToRem(14),

      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
    },

    selectMenu: {
      background: "none",
      height: "auto",
      minHeight: "auto",
      overflow: "unset",
    },

    icon: {
      display: "inline-flex",
      color: text.main,
      right: pxToRem(8),
    },
  },
};

export default select;
